<template>
  <header class="page-header">
    <!-- RD Navbar-->
    <div class="rd-navbar-wrap">
      <nav
        class="rd-navbar rd-navbar-classic"
        data-layout="rd-navbar-fixed"
        data-sm-layout="rd-navbar-fixed"
        data-md-layout="rd-navbar-fixed"
        data-md-device-layout="rd-navbar-fixed"
        data-lg-layout="rd-navbar-fixed"
        data-lg-device-layout="rd-navbar-fixed"
        data-xl-layout="rd-navbar-static"
        data-xl-device-layout="rd-navbar-static"
        data-lg-stick-up-offset="46px"
        data-xl-stick-up-offset="46px"
        data-xxl-stick-up-offset="46px"
        data-lg-stick-up="true"
        data-xl-stick-up="true"
        data-xxl-stick-up="true"
      >
        <div class="rd-navbar-main-outer">
          <div class="rd-navbar-main">
            <!-- RD Navbar Panel-->
            <div class="rd-navbar-panel">
              <!-- RD Navbar Toggle-->
              <button
                ref="navbarToggleBtnRef"
                class="rd-navbar-toggle"
                data-rd-navbar-toggle=".rd-navbar-nav-wrap"
              >
                <span></span>
              </button>
              <!-- RD Navbar Brand-->
              <div
                class="rd-navbar-brand"
                :set="
                  (logoContent = getContent(
                    layoutContent?.currentLocaleData,
                    layoutContent?.defaultLocaleData,
                    'logo'
                  ))
                "
              >
                <!--Brand-->
                <NuxtLink :to="localizePath('/')" class="brand brand-logo">
                  <AtomicPicture
                    :src="logoContent?.large"
                    alt=""
                    width="282"
                    height="141"
                  />
                </NuxtLink>
                <NuxtLink
                  :to="localizePath('/')"
                  class="brand brand-logo-stuck"
                >
                  <AtomicPicture
                    :src="logoContent?.small"
                    alt=""
                    width="115"
                    height="62"
                  />
                </NuxtLink>
                <div class="rd-navbar-brand-triangle"></div>
              </div>
              <!-- .rd-navbar-static .rd-navbar-dropdown -->
              <ul class="select-lang-mobile rd-navbar-nav rd-navbar-nav-right">
                <SelectLang />
              </ul>
            </div>
            <div class="rd-navbar-main-element">
              <div ref="navbarNavWrapRef" class="rd-navbar-nav-wrap">
                <!-- RD Navbar Nav-->
                <ul
                  class="rd-navbar-nav rd-navbar-nav-left"
                  :set="
                    (leftItemsContent = getContent(
                      layoutContent?.currentLocaleData,
                      layoutContent?.defaultLocaleData,
                      'leftItems'
                    ))
                  "
                >
                  <li
                    v-for="(item, index) in leftItemsContent"
                    :key="index"
                    class="rd-nav-item"
                  >
                    <AtomicLink
                      class="rd-nav-link"
                      :href="item.url"
                      :targetBlank="item.targetBlank"
                      @click="closeSidebar"
                    >
                      {{ item.label }}
                    </AtomicLink>

                    <ul
                      v-if="item.subMenu?.length"
                      class="rd-menu rd-navbar-dropdown"
                    >
                      <li
                        v-for="(subItem, idx) in item.subMenu"
                        :key="idx"
                        class="rd-dropdown-item"
                      >
                        <AtomicLink
                          class="rd-dropdown-link"
                          :href="subItem.url"
                          :targetBlank="item.targetBlank"
                          @click="closeSidebar"
                        >
                          {{ subItem.label }}
                        </AtomicLink>
                      </li>
                    </ul>
                  </li>
                </ul>
                <ul
                  class="rd-navbar-nav rd-navbar-nav-right"
                  :set="
                    (rightItemsContent = getContent(
                      layoutContent?.currentLocaleData,
                      layoutContent?.defaultLocaleData,
                      'rightItems'
                    ))
                  "
                >
                  <li
                    v-for="(item, index) in rightItemsContent"
                    :key="index"
                    class="rd-nav-item"
                  >
                    <AtomicLink
                      class="rd-nav-link"
                      :href="item.url"
                      :targetBlank="item.targetBlank"
                      @click="closeSidebar"
                    >
                      {{ item.label }}
                    </AtomicLink>

                    <ul
                      v-if="item.subMenu?.length"
                      class="rd-menu rd-navbar-dropdown"
                    >
                      <li
                        v-for="(subItem, idx) in item.subMenu"
                        :key="idx"
                        class="rd-dropdown-item"
                      >
                        <AtomicLink
                          class="rd-dropdown-link"
                          :href="subItem.url"
                          :targetBlank="item.targetBlank"
                          @click="closeSidebar"
                        >
                          {{ subItem.label }}
                        </AtomicLink>
                      </li>
                    </ul>
                  </li>

                  <SelectLang class="select-lang-desktop" />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script setup>
const { localizePath, getContent } = useProjectMethods();

const contentParams = {
  contentKey: "layoutContent",
  contentRoute: ["layout", "navigation"],
};

const { getContentData } = useContentLogic(contentParams);
const { data: layoutContent } = await useLazyAsyncData(getContentData);

const navbarNavWrapRef = ref(null);
const navbarToggleBtnRef = ref(null);

const closeSidebar = async () => {
  if (!navbarNavWrapRef.value || !navbarToggleBtnRef.value) return;
  await nextTick();

  [navbarNavWrapRef.value, navbarToggleBtnRef.value].forEach((ref) => {
    ref.classList.remove("active");
  });
};
</script>

<style lang="scss" scoped>
.select-lang-mobile {
  margin-top: 0;
  margin-left: auto;

  @media (min-width: 1200px) {
    display: none;
  }
}

.select-lang-desktop {
  display: none;

  @media (min-width: 1200px) {
    display: inline-block;
  }
}
</style>
